import { Container } from "@mui/material";
import React from "react";
import classes from "./Head.module.css";
import home from "../utils/images/home.png";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

const Head = () => {
  return (
    <Container
      sx={{
        width: "100vw",
        display: "flex",
        marginTop: "5em",
        justifyContent: "space-evenly",
      }}
    >
      <div className={classes.headContent}>
        <h1>Let’s take your analytics to the next level</h1>
        <p>
          Journey Analytics enables you to build Customer 360 Data Applications
          in the cloud with easier tracking of Journey stages across variety of
          Platforms.
        </p>
        <Link to="/login">
          <Button
            sx={{ backgroundColor: "#1CB4C4", marginTop: "2em" }}
            variant="contained"
          >
            Get Started
          </Button>
        </Link>
      </div>
      <div>
        <div className={classes.headCard}>
          <div className={classes.headCardBody}>
            <img src={home} alt="" />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Head;
